(function (angular) {
    'use strict';

    angular.module('dashboard')

        .component('dashboardMessagesToday', {
            bindings: {
                data: "<"
            },
            controller: ["$element", "chartFactoryService", function ($element, chartFactoryService) {
                var ctrl = this;

                ctrl.$onChanges = function (changes) {
                    if (changes.data.currentValue) {
                        ctrl.data = changes.data.currentValue;

                        if (ctrl.horizontalBar) {
                            ctrl.horizontalBar.destroy();
                        }

                        Chart.elements.Rectangle.prototype.draw = chartFactoryService.roundedCornersBars;

                        ctrl.horizontalBar = new Chart(ctrl.ctx, {
                            type: 'horizontalBar',
                            data: {
                                labels: ctrl.data.labels,
                                datasets: ctrl.data.datasets,
                                colors: ctrl.data.colors
                            },
                            options: {
                                plugins: {
                                    datalabels: {
                                        display: false
                                    }
                                },
                                responsive: true,
                                legend: {
                                    display: false,
                                },
                                title: {
                                    display: false,
                                },
                                animation: {
                                    animateScale: true,
                                    animateRotate: true
                                },
                                scales: {
                                    xAxes: [{
                                        gridLines: {
                                            display: false,
                                        },
                                        ticks: {
                                            beginAtZero: true,
                                            userCallback: function (label, index, labels) {
                                                // when the floored value is the same as the value we have a whole number
                                                if (Math.floor(label) === label) {
                                                    return label;
                                                }
                                            },

                                        }
                                    }],
                                    yAxes: [{
                                        gridLines: {
                                            display: false
                                        }
                                    }]
                                }
                            },
                        });

                    }
                }

                ctrl.$onInit = function () {
                    var canvas = $element.find("canvas");
                    ctrl.ctx = canvas[0].getContext("2d");

                }

            }],
            template: '<div class="col-md-12 card"><canvas></canvas></div>'
        })

})(window.angular);